
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFilter3 as ObiFilter3Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-filter-3.js';
 
 
 

 
 export const ObiFilter3 = createComponent({
   react: React,
   tagName: 'obi-filter-3',
   elementClass: ObiFilter3Element,
   events: {
     
   }
  });
 
 